interface SuggestionRowLike {
  readonly id?: string;
  readonly status?: string;
}

interface PagedDataLike<Row> {
  readonly data?: ReadonlyArray<Row>;
}

export function markOutcomeSuggestionPromoting<T>(prev: T, vars: Record<string, unknown>): T {
  if (prev === null || prev === undefined || typeof prev !== 'object') return prev;
  const id = vars.id;
  if (typeof id !== 'string' || id.length === 0) return prev;
  if (!('data' in prev) || !Array.isArray((prev as PagedDataLike<SuggestionRowLike>).data)) {
    return prev;
  }

  const envelope = prev as PagedDataLike<SuggestionRowLike>;
  let changed = false;
  const data = (envelope.data as ReadonlyArray<SuggestionRowLike>).map((row) => {
    if (row.id !== id || row.status === 'promoting') return row;
    changed = true;
    return { ...row, status: 'promoting' };
  });

  return changed ? ({ ...(prev as object), data } as T) : prev;
}
